<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BSEbXD/tc-custom/9780226732244.jpg?1726454432960" alt="This image is the cover for the book Sun Ra's Chicago, Historical Studies of Urban America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sun Ra's Chicago, Historical Studies of Urban America
      </h1>
      <p class="bookDescription body article font2">
        <b>“Sites provides crucial context on how Chicago’s Afrocentrist philosophy, religion, and jazz scenes helped turn Blount into Sun Ra.</b><b>” —</b><b><i>Chicago Reader</i></b><br/>  <br/> Sun Ra (1914–93) was one of the most wildly prolific and unfailingly eccentric figures in the history of music. Renowned for extravagant performances in which his Arkestra appeared in neo-Egyptian garb, the keyboardist and bandleader also espoused an interstellar cosmology that claimed the planet Saturn as his true home. In <i>Sun Ra’s Chicago</i>, William Sites brings this visionary musician back to earth—specifically to the city’s South Side, where from 1946 to 1961 he lived and relaunched his career. The postwar South Side was a hotbed of unorthodox religious and cultural activism: Afrocentric philosophies flourished, storefront prophets sold “dream-book bibles,” and Elijah Muhammad was building the Nation of Islam. It was also an unruly musical crossroads where the man then known as Sonny Blount drew from an array of intellectual and musical sources—from radical nationalism, revisionist Christianity, and science fiction to jazz, blues, Latin dance music, and pop exotica—to construct a philosophy and performance style that imagined a new identity and future for African Americans. <i>Sun Ra’s Chicago</i> shows that late twentieth-century Afrofuturism emerged from a deep, utopian engagement with the city—and that by excavating the postwar black experience of Sun Ra’s South Side milieu, we can come to see the possibilities of urban life in new ways.<br/>  <br/><b>“Four stars . . . Sites makes the engaging argument that the idiosyncratic jazz legend’s penchant for interplanetary journeys and African American utopia was in fact inspired by urban life right on Earth.” —</b><i>Spectrum Culture</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Sites
      </h2>
      
      <p class="authorDescription body article"><B>William Sites</B> is associate professor in Crown Family School of Social Work, Policy, and Practice at the University of Chicago.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0feb2d33